import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const softwareVersionDetailConfigProviderEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "ai-rovo-actions-software-version-detail-config-provider" */ './SoftwareVersionDetailConfigProvider'
		).then((module) => module.SoftwareVersionDetailConfigProviderEntry),
	),
	getPreloadProps: () => ({}),
});
